<template>
  <div class="px-2 py-2 bg-grey-lighten-5 min-h-screen d-flex justify-center rounded-xl">
    <div style=" width: 100%;">
      
      <!-- Header Hero -->
       <!--
      <div class="text-center mb-10">
        <v-avatar color="pink-lighten-5" size="80" class="mb-4 elevation-3">
          <i class="fa-solid fa-paintbrush" style="font-size: 32px; color: #D81B60;"></i>
        </v-avatar>
        <h1 class="text-h4 font-weight-black text-grey-darken-3 mb-2">Solicitud de Diseño</h1>
        <p class="text-subtitle-1 text-medium-emphasis" style="max-width: 600px; margin: 0 auto;">
          Describe tu requerimiento gráfico o campaña y nuestro equipo creativo lo hará realidad.
        </p>
      </div>
      -->
      <v-img :src="require('@/assets/header-solicitud.png')" width="100%" max-width="100%"
       class="rounded-xl mb-4" contain ></v-img>

      <!-- Loading State -->
      <div v-if="loadingSearchTicketReferencia" class="py-8 text-center">
        <v-progress-circular color="primary" indeterminate size="40"></v-progress-circular>
        <div class="mt-4 text-subtitle-2 text-medium-emphasis">Cargando referencia...</div>
      </div>

      <!-- Error State -->
      <v-alert v-if="notfoundreferencia" type="error" variant="tonal" border="start" class="mb-6 rounded-lg bg-red-lighten-5">
        <template v-slot:prepend>
          <i class="fa-solid fa-circle-exclamation mr-2" style="font-size: 20px; color: #D32F2F;"></i>
        </template>
        Ticket de referencia no encontrado
      </v-alert>

      <!-- Ticket de Referencia (Si existe) -->
      <v-card v-if="ticket_referencia" elevation="0" class="rounded-xl border mb-8 bg-white overflow-hidden">
        <div class="d-flex flex-column flex-md-row">
          <div class="bg-indigo-lighten-5 pa-6 d-flex flex-column align-center justify-center min-w-150">
            <div class="text-h4 font-weight-black text-indigo-darken-4">{{ formatFechaCustom(ticket_referencia.created_at, 'DD') }}</div>
            <div class="text-caption text-uppercase font-weight-bold text-indigo-darken-2">{{ formatFechaCustom(ticket_referencia.created_at, 'MMM YYYY') }}</div>
          </div>
          <div class="pa-6 flex-grow-1">
            <div class="text-overline text-primary font-weight-bold mb-1">TICKET REFERENCIA</div>
            <div class="text-h6 font-weight-bold mb-2 text-grey-darken-3">{{ ticket_referencia.asunto }}</div>
            <div class="d-flex gap-2 mb-3">
              <v-chip size="small" color="primary" variant="tonal" label class="font-weight-bold">{{ ticket_referencia.categoria.nombre }}</v-chip>
              <v-chip size="small" :color="ticket_referencia.prioridad.color || 'grey'" variant="flat" class="text-white font-weight-bold">
                {{ ticket_referencia.prioridad.nombre }}
              </v-chip>
            </div>
            <div class="text-caption text-medium-emphasis d-flex align-center">
              <i class="fa-solid fa-user mr-2" style="font-size: 12px;"></i>
              Por: {{ capitalizeWords(ticket_referencia.user.nombres) + ' ' + capitalizeWords(ticket_referencia.user.apellidos) }}
            </div>
          </div>
        </div>
      </v-card>

      <!-- Formulario Principal -->
      <v-card elevation="0" class="rounded-xl border shadow-card bg-white">
        <v-form v-model="formValidate" ref="formTicket">
          <v-card-text class="pa-6 pa-md-10">
            
            <!-- SECCIÓN 1: CONTACTO -->
            <div class="mb-8">
              <div class="d-flex align-center justify-space-between mb-6">
                <div class="d-flex align-center">
                  <div class="mr-4 rounded-circle bg-teal-lighten-5 d-flex align-center justify-center" style="width: 40px; height: 40px;">
                    <i class="fa-solid fa-address-book" style="font-size: 18px; color: #00796B;"></i>
                  </div>
                  <h2 class="text-h6 font-weight-bold text-grey-darken-3">Datos de Contacto</h2>
                </div>
                
                <!-- Toggle Usuario -->
                <div class="d-flex bg-grey-lighten-3 rounded-pill p-1 border" v-if="!this.isRoleVisitor()" style="padding: 4px;">
                  <v-btn :variant="!ticket.otro_usuario ? 'flat' : 'text'" :color="!ticket.otro_usuario ? 'white' : 'transparent'"
                    :class="{'shadow-sm text-grey-darken-4 font-weight-bold': !ticket.otro_usuario, 'text-medium-emphasis font-weight-regular': ticket.otro_usuario}"
                    class="rounded-pill text-capitalize px-6 transition-all" size="small" elevation="0"
                    @click="ticket.otro_usuario = false; resetInitTicket(); initTicket()">
                    Soy Yo
                  </v-btn>
                  <v-btn :variant="ticket.otro_usuario ? 'flat' : 'text'" :color="ticket.otro_usuario ? 'white' : 'transparent'"
                    :class="{'shadow-sm text-grey-darken-4 font-weight-bold': ticket.otro_usuario, 'text-medium-emphasis font-weight-regular': !ticket.otro_usuario}"
                    class="rounded-pill text-capitalize px-6 transition-all" size="small" elevation="0"
                    @click="ticket.otro_usuario = true; resetInitTicket(); ticket.correo = ''">
                    Es Otro
                  </v-btn>
                </div>
              </div>

              <v-row dense>
                <v-col cols="12" v-if="solicitantenofound">
                  <v-alert type="error" variant="tonal" density="compact" class="mb-2" closable>Usuario no encontrado</v-alert>
                </v-col>

                <template v-if="!ticket.otro_usuario">
                  <v-col cols="12" md="6">
                    <v-text-field label="Tu Correo" placeholder="personal o institucional" variant="outlined" density="comfortable" color="primary" bg-color="grey-lighten-5"
                      :rules="[rules.required, rules.email]" v-model="ticket.correo" ref="correoOtroUsuario">
                      <template v-slot:prepend-inner>
                        <i class="fa-solid fa-envelope mr-2" style="font-size: 16px; color: #757575;"></i>
                      </template>
                    </v-text-field>
                  </v-col>
                </template>

                <template v-else>
                  <v-col cols="12" md="6">
                    <v-autocomplete label="Buscar Usuario" placeholder="Escribe el correo..." variant="outlined" density="comfortable" color="primary"
                      bg-color="grey-lighten-5" :rules="[rules.required, rules.email]" v-model="ticket.correo" :items="listaUsuarios"
                      item-title="email" item-value="email" auto-select-first chips>
                      <template v-slot:prepend-inner>
                        <i class="fa-solid fa-magnifying-glass mr-2" style="font-size: 16px; color: #757575;"></i>
                      </template>
                      <template v-slot:append-inner>
                        <v-btn icon variant="text" density="compact" @click="getUsuarioSolicitante()" :loading="loadingSolicitante" color="primary">
                          <i class="fa-solid fa-arrow-right" style="font-size: 16px;"></i>
                        </v-btn>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field label="Nombre Completo" readonly variant="outlined" density="comfortable" color="primary" bg-color="grey-lighten-4"
                      :rules="[rules.required]" v-model="ticket.solicitante.nombrecompleto">
                      <template v-slot:prepend-inner>
                        <i class="fa-solid fa-user mr-2" style="font-size: 16px; color: #757575;"></i>
                      </template>
                    </v-text-field>
                  </v-col>
                </template>

                <v-col cols="12" md="6">
                  <v-text-field label="Teléfono" placeholder="Para llamadas" variant="outlined" density="comfortable" color="primary" bg-color="grey-lighten-5"
                    :rules="[rules.required, rules.celular]" v-model="ticket.celular">
                    <template v-slot:prepend-inner>
                      <i class="fa-solid fa-phone mr-2" style="font-size: 16px; color: #757575;"></i>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field label="WhatsApp" placeholder="Para mensajes" variant="outlined" density="comfortable" color="success" bg-color="grey-lighten-5"
                    v-model="ticket.whatsapp">
                    <template v-slot:prepend-inner>
                      <i class="fa-brands fa-whatsapp mr-2" style="font-size: 18px; color: #4CAF50;"></i>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select label="Sede" placeholder="Selecciona ubicación" variant="outlined" density="comfortable" color="primary" bg-color="grey-lighten-5"
                    v-model="ticket.sede" :items="listSedes" item-value="abreviatura" item-title="abreviatura" :rules="[rules.required]">
                    <template v-slot:prepend-inner>
                      <i class="fa-solid fa-map-pin mr-2" style="font-size: 16px; color: #757575;"></i>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12" md="6" v-if="ticket.otro_usuario">
                  <v-select label="Asignar Agente (Opcional)" variant="outlined" density="comfortable" color="primary" bg-color="grey-lighten-5"
                    v-model="ticket.agente" :items="listAgentes" item-value="idagente" item-title="user.nombres">
                    <template v-slot:prepend-inner>
                      <i class="fa-solid fa-user-tie mr-2" style="font-size: 16px; color: #757575;"></i>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete label="CC (Copia Oculta)" placeholder="Compartir ticket con otros usuarios..." multiple chips closable-chips
                    variant="outlined" density="comfortable" color="primary" bg-color="grey-lighten-5"
                    v-model="ticket.copy_ticket_users" :items="listaUsuariosFilter" item-value="email" 
                    :item-title="(val) => oneName(val.nombres) + ' ' + oneName(val.apellidos) + ' - ' + val.email">
                    <template v-slot:prepend-inner>
                      <i class="fa-solid fa-share-nodes mr-2" style="font-size: 16px; color: #757575;"></i>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </div>

            <v-divider class="my-8 border-opacity-15"></v-divider>

            <!-- SECCIÓN 2: DETALLES -->
            <div>
              <div class="d-flex align-center mb-6">
                <div class="mr-4 rounded-circle bg-purple-lighten-5 d-flex align-center justify-center" style="width: 40px; height: 40px;">
                  <i class="fa-solid fa-file-lines" style="font-size: 18px; color: #7B1FA2;"></i>
                </div>
                <h2 class="text-h6 font-weight-bold text-grey-darken-3">Detalles de la Solicitud</h2>
              </div>

              <v-row dense>
                <v-col cols="12" md="6">
                  <v-select label="Tipo de Ticket" variant="outlined" density="comfortable" color="primary" bg-color="grey-lighten-5"
                    :rules="[rules.required]" v-model="ticket.tipo_ticket" :items="listTipo" item-value="idtipo" item-title="nombre">
                    <template v-slot:item="{ props, item }">
                      <v-list-item v-bind="props" :subtitle="item.raw.descripcion"></v-list-item>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select label="Categoría" variant="outlined" density="comfortable" color="primary" bg-color="grey-lighten-5"
                    :loading="loadingcategorias" :rules="[rules.required]" v-model="ticket.categoria_ticket"
                    :items="ticket.tipo_ticket != '' && !loadingcategorias ? listCategorias : []" item-value="idcategoria" item-title="nombre">
                  </v-select>
                </v-col>

                <v-col cols="12" md="6" v-if="listsubcategorias.length > 0">
                  <v-select label="Subcategoría (Opcional)" variant="outlined" density="comfortable" color="primary" bg-color="grey-lighten-5"
                    :loading="loadingsubcategorias" v-model="ticket.subcategoria_id"
                    :items="ticket.categoria_ticket != '' && !loadingsubcategorias ? listsubcategorias : []" item-value="id_subcategoria" item-title="nombre">
                  </v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select label="Prioridad" variant="outlined" density="comfortable" color="primary" bg-color="grey-lighten-5"
                    :rules="[rules.required]" v-model="ticket.prioridad_ticket" :items="prioridadesWithFilter"
                    item-value="idprioridad" item-title="nombre">
                    <template v-slot:prepend-inner>
                      <i class="fa-solid fa-triangle-exclamation mr-2" style="font-size: 16px; color: #F57F17;"></i>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12" v-if="prioridadObject">
                  <v-alert :color="prioridadObject.color" variant="tonal" border="start" density="compact" class="rounded-lg mb-4">
                    <template v-slot:prepend>
                      <i class="fa-solid fa-circle-info mr-2" style="font-size: 18px; color: inherit;"></i>
                    </template>
                    {{ prioridadObject.descripcion }}
                  </v-alert>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select label="Destino" placeholder="Selecciona un destino" variant="outlined" density="comfortable" color="primary" bg-color="grey-lighten-5"
                    v-model="ticket.destino_id" :items="listDestinos" item-value="id" item-title="nombre">
                    <template v-slot:prepend-inner>
                      <i class="fa-solid fa-bullseye mr-2" style="font-size: 16px; color: #757575;"></i>
                    </template>
                    <template v-slot:item="{ props, item }">
                      <v-list-item v-bind="props" :subtitle="item.raw.descripcion"></v-list-item>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select label="Formato" placeholder="Selecciona un formato" variant="outlined" density="comfortable" color="primary" bg-color="grey-lighten-5"
                    v-model="ticket.formato_id" :items="listFormatos" item-value="id" item-title="nombre">
                    <template v-slot:prepend-inner>
                      <i class="fa-solid fa-file-image mr-2" style="font-size: 16px; color: #757575;"></i>
                    </template>
                    <template v-slot:item="{ props, item }">
                      <v-list-item v-bind="props" :subtitle="item.raw.descripcion"></v-list-item>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12">
                  <v-text-field label="Link de Referencia" placeholder="Ej: https://..." variant="outlined" density="comfortable" color="primary" bg-color="grey-lighten-5"
                    v-model="ticket.link_referencia">
                    <template v-slot:prepend-inner>
                      <i class="fa-solid fa-link mr-2" style="font-size: 16px; color: #757575;"></i>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <div class="mb-1 text-subtitle-2 font-weight-bold text-grey-darken-3 ml-1">Asunto</div>
                  <v-text-field v-if="!$route.query.ref" placeholder="Ej: Error al acceder al sistema de diseño" variant="outlined" density="comfortable" color="primary" bg-color="grey-lighten-5"
                    class="font-weight-bold" :rules="[rules.required]" v-model="ticket.asunto"></v-text-field>
                  
                  <div v-else class="rounded-lg border pa-4 bg-grey-lighten-5 mb-4">
                    <div class="text-h6 font-weight-bold">{{ ticket.asunto }}</div>
                  </div>
                </v-col>

                <v-col cols="12">
                  <div class="d-flex justify-space-between align-center mb-2">
                    <div class="text-subtitle-2 font-weight-bold text-grey-darken-3 ml-1">Descripción Detallada</div>
                    <div class="text-caption text-medium-emphasis">Sé lo más específico posible</div>
                  </div>
                  <div class="text-medium-emphasis">Puedes agregar el link de un archivo o diseño de referencia (asegurate de darnos acceso libre a tu archivo)</div>
                  <div class="editor-wrapper rounded-lg overflow-hidden border">
                    <v-textarea class="d-none" ref="descripcion" name="descripcion" :rules="[rules.required]" v-model="ticket.body"></v-textarea>
                    <EditorTexto
                      v-model="ticket.body"
                      :height="configTiny.height"
                      :placeholder="configTiny.placeholder"
                    />
                  </div>
                  <div v-if="!ticket.body" class="text-caption text-red mt-1 ml-1">* La descripción es obligatoria</div>
                </v-col>

                <v-col cols="12">
                  <div class="mb-2 text-subtitle-2 font-weight-bold text-grey-darken-3 ml-1">Adjuntar Archivos (Opcional)</div>
                  <FileUploadDragDrop 
                    v-model="archivosAdjuntos"
                    :multiple="true"
                    :maxSizeMB="10"
                  />
                </v-col>
              </v-row>
            </div>

            <v-divider class="my-10 border-opacity-15"></v-divider>

            <div class="d-flex justify-center">
              <v-btn @click="sendTicket()" size="x-large" rounded="xl" elevation="6" class="px-12 text-white font-weight-bold"
                height="56"
                style="background: linear-gradient(135deg, #002B49 0%, #005691 100%); letter-spacing: 1px; min-width: 250px;">
                <i class="fa-solid fa-paper-plane mr-3" style="font-size: 18px; color: white;"></i>
                ENVIAR SOLICITUD
              </v-btn>
            </div>

          </v-card-text>
        </v-form>
      </v-card>

      <!-- Dialogo Info Prioridades -->
      <v-dialog v-model="dialogPrioridades" width="500">
        <v-card class="rounded-xl">
          <v-card-text class="pa-0">
            <v-img :src="require('@/assets/prioridades.jpeg')" cover></v-img>
          </v-card-text>
          <v-card-actions class="justify-center pa-4">
            <v-btn color="primary" variant="tonal" rounded="lg" @click="dialogPrioridades = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import EditorTexto from "@/components/EditorTexto.vue";
import FileUploadDragDrop from "@/components/FileUploadDragDrop.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import Filters from "@/modules/Shared/Filters"
export default {
  mixins: [Filters],
  components: {
    EditorTexto,
    FileUploadDragDrop,
  },
  data() {
    return {
      dialogPrioridades: false,
      formValidate: true,
      isFormValid: false,
      configTiny: {
        selector: "textarea#basic-example",
        plugins: [
          "advlist",
          "autolink",
          "lists",
          "link",
          "preview",
          "anchor",
          "code",
          "fullscreen",
          "table",
          "wordcount",
          "fullscreen",
          "image",
          "imagetools"
        ],
        menubar: false,
        statusbar: true,
        toolbar:
          "undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | removeformat link",
        content_style:
          "body { font-family:'Plus Jakarta Sans',Helvetica,Arial,sans-serif; font-size:14px; line-height: 1.6; color: #374151; }",
        fullscreen_native: false,
        automatic_uploads: true,
        height: 300,
        placeholder: "Describe detalladamente tu solicitud...",
      },
      prioridadObject: null,
      hiddenPrioridad: false,

      prioridadesWithFilter: []
    };
  },
  watch: {
    'ticket.tipo_ticket': function (newvalue, oldvalue) {
      if (newvalue) {
        this.ticket.categoria_ticket = ""
        this.filterCategoria.tipo_id = newvalue

        if (this.user.role_user.name == 'VISITANTE') {
          this.filterCategoria.tipo_usuario = this.user.tipouser.split(',')

        }

        this.getCategoriasAxios()
        if (this.ticket_referencia) {
          this.ticket.categoria_ticket = this.ticket_referencia.categoria_ticket
        }


        //ver que tipo de ticket es y ocultar la prioridad
       let resultadoFiltrado = this.listTipo.filter(tipo => tipo.idtipo === newvalue);
        let IsRequerimiento = resultadoFiltrado.some(tipo => tipo.nombre === "REQUERIMIENTO");

        if(IsRequerimiento)
        {
          this.prioridadesWithFilter =  this.listPrioridad.filter(prioridad => prioridad.nombre !== 'CRITICA');

        }else
        {
          this.prioridadesWithFilter =  this.listPrioridad
        }
      }
    },

    'ticket.categoria_ticket': function (newvalue, oldvalue) {
      if (newvalue) {
        this.ticket.subcategoria_id = ""
        this.filterSubcategoria.categoria_id = newvalue

        if (this.user.role_user.name == 'VISITANTE') {
          this.filterSubcategoria.tipo_usuario = this.user.tipouser.split(',')
        }


        this.getSubCategoriasAxios()
        if (this.ticket_referencia && this.ticket_referencia.subcategoria_id) {
          this.ticket.subcategoria_id = this.ticket_referencia.subcategoria_id
        }
      }
    },

    'ticket.otro_usuario': function (newvalue) {
      if (newvalue) {
        this.resetInitTicket()
        this.ticket.correo = ''
      } else {
        this.initTicket()
      }
    },

    'ticket_referencia': function (newvalue) {
      if (newvalue) {
        this.setTicketWithReferencia(this.ticket_referencia)

      }
    },

    'ticket.correo': function (newvalue) {
      if (this.ticket.otro_usuario) {
        this.getUsuarioSolicitante()
      }
    },

    'ticket.prioridad_ticket': function (newvalue){
      if(newvalue)
      {
        let prioridadObject = this.listPrioridad.filter(p => p.idprioridad == newvalue)
         this.prioridadObject = prioridadObject[0] ?? null
   
      }
    },

    'ticket.celular': function (newval){
      
      if(newval && this.ticket.whatsapp == '')
      {
        this.ticket.whatsapp = newval
      }
    }



  },
  computed: {
    ...mapState("configuracion/tipo", ["listTipo"]),
    ...mapState("configuracion/categoria", ["listCategorias", "loadingcategorias", "filterCategoria"]),
    ...mapState("configuracion/subcategoria", ["listsubcategorias", "loadingsubcategorias", "filterSubcategoria"]),
    ...mapState("configuracion/prioridad", ["listPrioridad"]),
    ...mapState("configuracion/estado", ["listEstados"]),
    ...mapState("configuracion/sede", ["listSedes"]),
    ...mapState("configuracion/agente", ["listAgentes"]),
    ...mapState("configuracion/destino", ["listDestinos"]),
    ...mapState("configuracion/formato", ["listFormatos"]),
    ...mapState(["user"]),
    ...mapState('tickets/utiles',["apiTynyMCE"]),
    ...mapState('usuarios', ["listaUsuarios"]),
    ...mapState("tickets/registroticket", ["ticket", "solicitante", "loadingSolicitante", 'solicitantenofound', 'copiaCorreo', "ticket_referencia", "loadingSearchTicketReferencia", "notfoundreferencia"]),
    
    listaUsuariosFilter (){
      const filterUser = this.listaUsuarios.filter(elm => elm.email !== this.ticket.correo && elm.role_user.name !== 'AGENTE' && elm.role_user.name !== 'SUPERADMINISTRADOR')
      return filterUser;
    },

    // Computed property para sincronizar archivos con el store
    archivosAdjuntos: {
      get() {
        return this.ticket.fileadjunto || [];
      },
      set(files) {
        // Actualizar directamente el array en el store
        this.$store.state.tickets.registroticket.ticket.fileadjunto = files;
      }
    }
  
  },

  methods: {
    ...mapActions("tickets/registroticket", ["createTicketAxios", "getColaborador", "getEstudiante", "getUsuarioSolicitante", "getTicketReferencia"]),

    ...mapMutations("tickets/registroticket", ['changeFileInput', 'deleteFileUpload', 'initTicket', 'resetInitTicket', 'addEmailCC', 'removeCC', 'setTicketWithReferencia', 'resetTicketReferencia', 'resetTicket']),

    ...mapActions('configuracion/categoria', ['getCategoriasAxios']),

    ...mapActions('configuracion/subcategoria', ['getSubCategoriasAxios']),

    ...mapActions('configuracion/agente', ['getAgentes']),

    ...mapActions('configuracion/destino', ['getDestinosAxios']),

    ...mapActions('configuracion/formato', ['getFormatosAxios']),

    ...mapActions('usuarios', ['getAllUser']),

    getApiDNI() {
      if (this.ticket.tipo_solicitante === 'COLABORADOR') {
        this.getColaborador()
      }

      if (this.ticket.tipo_solicitante === 'ESTUDIANTE') {
        this.getEstudiante()
      }
    },

    async sendTicket()
    {
      this.$refs.formTicket.validate()
      this.isFormValid = await this.$refs.formTicket.validate();

      if (!this.isFormValid.valid) {
        console.log(this.isFormValid)
        
        // Obtener el primer campo con error y hacer scroll
        const firstError = this.isFormValid.errors[0];
        if (firstError && firstError.id) {
          this.scrollToField(firstError.id);
        }
        
        // Mostrar alerta al usuario
        this.$toast.error('Por favor completa todos los campos requeridos', {
          position: 'top-right',
          duration: 3000
        });
        
        return
      }

      this.createTicketAxios()
    },

    scrollToField(fieldName) {
      // Intentar obtener el elemento del DOM usando el ID del campo
      this.$nextTick(() => {
        const fieldElement = document.getElementById(fieldName);
        
        if (fieldElement) {
          // Hacer scroll al elemento
          fieldElement.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
          
          // Intentar hacer focus en el campo si es posible
          setTimeout(() => {
            const inputElement = fieldElement.querySelector('input, textarea, select');
            if (inputElement) {
              inputElement.focus();
            }
          }, 500);
        } else {
          // Si no se encuentra por ID, intentar con refs
          const fieldRef = this.$refs[fieldName];
          if (fieldRef && fieldRef.$el) {
            fieldRef.$el.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'center' 
            });
          }
        }
      });
    },


  },

  created() {
    if (this.$vuetify.display.lgAndUp) {
      this.configTiny.height = 400

    } else if (this.$vuetify.display.mdAndDown) {
      this.configTiny.height = 300
    }
  },

  mounted() {
    this.ticket.otro_usuario = false
    this.resetInitTicket()
    this.resetTicket()
    this.initTicket()
    this.getAgentes()
    this.getDestinosAxios()
    this.getFormatosAxios()
    this.resetTicketReferencia()
    if (this.$route.query.ref) {
      this.getTicketReferencia(this.$route.query.ref)
    }

    this.getAllUser()


  }
};
</script>

<style scoped>
.min-h-screen {
  min-height: 100vh;
}

.shadow-card {
  box-shadow: 0 4px 20px -5px rgba(0, 0, 0, 0.05) !important;
}

.editor-wrapper {
  border: 1px solid #e0e0e0;
  transition: border-color 0.2s;
}

.editor-wrapper:hover {
  border-color: #bdbdbd;
}

.gap-2 {
  gap: 8px;
}

.min-w-150 {
  min-width: 150px;
}
</style>